const USER_DATA = {
	'kipacti@gmail.com': { email: 'kipacti@gmail.com', password: "asdfasdf" },
	'codeit1@codeit.com': { email: 'codeit1@codeit.com', password: "codeit101!" },
	'codeit2@codeit.com': { email: 'codeit2@codeit.com', password: "codeit202!" },
	'codeit3@codeit.com': { email: 'codeit3@codeit.com', password: "codeit303!" },
	'codeit4@codeit.com': { email: 'codeit4@codeit.com', password: "codeit404!" },
	'codeit5@codeit.com': { email: 'codeit5@codeit.com', password: "codeit505!" },
	'codeit6@codeit.com': { email: 'codeit6@codeit.com', password: "codeit606!" },
};

export default USER_DATA;
